/**
     * PaymentReceived.contract.ts — Event Contract System™ (generation v1).
     * Reserved publisher: a payment landed. Subscribers are wired and waiting; the production publisher lands with the v2 Mission Engine sprint.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const PaymentReceivedContract: EventContract = {
      name: 'PaymentReceived',
      version: 1,
      description: "Reserved publisher: a payment landed. Subscribers are wired and waiting; the production publisher lands with the v2 Mission Engine sprint.",
      publishers: [],
      subscribers: ["module:career","module:planner","sidebar"],
      fields: [
        { name: 'amount', type: 'number', required: false, description: "Payment amount in the recorded currency" },
    { name: 'currency', type: 'string', required: false, description: "ISO currency code" },
      ],
      allowExtraFields: true,
      timestampPolicy: "Publish time (Date.now()) when the payment is recorded.",
      stability: 'reserved',
      deprecated: false,
      example: null,
    };
    